import { Box, Grid } from "@material-ui/core";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import styles from "../communication-chat.module.css";
import { Search } from "react-feather";
import { FormControl, MenuItem, Select } from "@mui/material";
import { useState } from "react";

const FILTER_OPTIONS = [
  { value: "tenant", label: "Tenant", placeholder: "Search by tenants" },
  { value: "prospect", label: "Prospect", placeholder: "Search by prospects" },
];

const ProspectTenantSearch = (props) => {
  const [filterType, setFilterType] = useState("tenant");

  const currentFilter = FILTER_OPTIONS.find((o) => o.value === filterType);

  const filterByCallback = (option, props) => {
    const searchText = props.text.toLowerCase().trim();

    // Filter by selected type first
    if (option.type?.toLowerCase() !== filterType) return false;

    const fullName = `${option.first_name || ""} ${option.last_name || ""}`
      .toLowerCase()
      .trim();

    return (
      fullName.includes(searchText) ||
      option.first_name?.toLowerCase().includes(searchText) ||
      option.last_name?.toLowerCase().includes(searchText) ||
      option.phone?.includes(searchText) ||
      option.property_name?.toLowerCase().includes(searchText) ||
      option.apt_no?.toLowerCase().includes(searchText)
    );
  };

  return (
    <div className={`${styles.SearchSecMain}`}>
      <div className={`${styles.SelectTypeSearch} FormGroup`}>
        <FormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            {FILTER_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className={`${styles.SearchSecUnder} SearchSecUnder`}>
        <Search />
        <Typeahead
          id="search-tenants"
          key={filterType}
          labelKey={(option) => {
            if (option && option.first_name && option.last_name) {
              return option.first_name + " " + option.last_name;
            } else {
              return option.phone;
            }
          }}
          filterBy={(option, props) => filterByCallback(option, props)}
          options={props.typeaheadProspectTenantList}
          placeholder={currentFilter.placeholder}
          clearButton={true}
          flip={true}
          onChange={props.onSelectTypeahead}
          emptyLabel="No results found"
          renderMenuItemChildren={(option) => (
            <div className={`${styles.Width100}`}>
              {option && (option?.first_name || option?.last_name) ? (
                <div className={`${styles.SearchTPDeRow}`}>
                  <span className={`${styles.SearchTPDeName}`}>
                    {option?.first_name} {option?.last_name}
                  </span>
                  <span className={`${styles.SearchTPDeDe}`}>
                    <span>{option?.property_name}</span>
                    <span>{option?.apt_no}</span>
                  </span>
                  {/* {option?.type === "Tenant" && <span className={`${styles.UserType} ${styles.Tenant}`}>{option?.type}</span>}
                  {option?.type === "Prospect" && <span className={`${styles.UserType} ${styles.Prospect}`}>{option?.type}</span>} */}
                </div>
              ) : (
                <div>{option?.phone}</div>
              )}
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default ProspectTenantSearch;
